module.exports = "https://r.nearpod.com/assets/media/image/collaborate-67b277dbf6b671c058f3cc89c979e8b2.svg";